import { render, staticRenderFns } from "./FlowSourceConfigDetail.vue?vue&type=template&id=0954fa70&scoped=true&"
import script from "./FlowSourceConfigDetail.vue?vue&type=script&lang=js&"
export * from "./FlowSourceConfigDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0954fa70",
  null
  
)

export default component.exports